import React from "react";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import { Box, Typography, TextField } from "@mui/material";
import './DetailForm.css';
export const ProductForm = (props) => {
  const { name,
    channel,
    sku,
    price, currency } = props;
  return (
    <Box className="Box2">
      <TextField className="TextField2" value={name || ""} id="outlined-basic" label="Product Name" variant="outlined" InputLabelProps={{ shrink: name ? true : false }} />
      <TextField className="TextField2 " value={channel?.name || ""} id="outlined-basic" label="Channel" variant="outlined" InputLabelProps={{ shrink: name ? true : false }} />
      <TextField className="TextField2 mt-10" value={channel?.source_name || ""} id="outlined-basic" label="Service" variant="outlined" InputLabelProps={{ shrink: name ? true : false }} />
      <TextField className="TextField2 mt-10" value={sku || ""} id="outlined-basic" label="SKU" variant="outlined" InputLabelProps={{ shrink: name ? true : false }} />
      <FormControl className="TextField2 mt-10" InputLabelProps={{ shrink: name ? true : false }} >
        <InputLabel htmlFor="outlined-adornment-amount">Amount</InputLabel>
        <OutlinedInput
          id="outlined-adornment-amount"
          startAdornment={<InputAdornment position="start">{getCurr(currency)}</InputAdornment>}
          label="Amount"
          value={price || ""}
        />
      </FormControl>
    </Box>
  );
};


const getCurr = (currency) => {
  switch (currency) {
    case "GBP":
      return "£";
    case "USD":
      return "$";
    default:
      return "£";
  }
};
